var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 59,
    viewBox: "0 0 76 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.0419,
    y: 12.1473,
    width: 53.2,
    height: 35.9882,
    rx: 3.91176,
    fill: "#F3F4F9",
    stroke: "#0F90FF",
    strokeWidth: 1.56471
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.8242,
    y: 12.9297,
    width: 51.6353,
    height: 4.69412,
    fill: "#0F90FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 19.082,
    y: 20.7529,
    width: 35.9882,
    height: 3.12941,
    fill: "#C3C6DB"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 19.082,
    y: 25.4473,
    width: 25.0353,
    height: 3.12941,
    fill: "#C3C6DB"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 19.082,
    y: 31.7061,
    width: 7.82353,
    height: 1.56471,
    fill: "#C3C6DB"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 44.1182,
    y: 31.7061,
    width: 14.0824,
    height: 1.56471,
    fill: "#C3C6DB"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 34.7295,
    y: 34.8354,
    width: 14.0824,
    height: 1.56471,
    fill: "#C3C6DB"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 19.082,
    y: 39.5293,
    width: 40.6824,
    height: 3.12941,
    fill: "#C3C6DB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 12.9602V1H9.77084",
    stroke: "#9EA1B9",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M74.7744 12.9602V1H66.0036",
    stroke: "#9EA1B9",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 45.6516V57.6118H9.77084",
    stroke: "#9EA1B9",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M74.7744 45.6516V57.6118H66.0036",
    stroke: "#9EA1B9",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackDocument);
export default __webpack_public_path__ + "static/media/back-document.f47c02acb14a5c1c44880c1f4b70e047.svg";
export { ForwardRef as ReactComponent };